import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { createLoadingSelector } from '@hobs/utils/loading';
import DiscussionWidget from '@hobs/components/Discussion';
import {
  getDiscussion,
  sendMessage,
  markUnread,
  resetDiscussion,
  markAsSeen
} from '@hobs/actions/discussion';

class Discussion extends React.PureComponent {
  state = {
    discussionStatus: 1
  };

  componentDidMount() {
    this.setState({
      discussionStatus: this.props.status
    });
  }

  openDiscussion = () => {
    const id = this.props.match.params.assignmentId
      ? this.props.match.params.assignmentId
      : this.props.serviceRequestId;

    this.props.getDiscussion(id);
    this.props.markAsSeen(id);
  };

  getBackUrl(pathname) {
    if (pathname.includes('/edit')) {
      return pathname.split('/edit')[0];
    }

    if (pathname.includes('/tickets')) {
      return '/tickets';
    }

    if (pathname.includes('/requested-services')) {
      return '/requested-services';
    }

    if (pathname.includes('/service-requests')) {
      return `/service-requests/${this.props.match.params.partyId}`;
    }

    return this.props.history.location.pathname.split('/discussion')[0];
  }

  handleClose = markedUnread => {
    this.setState(
      {
        discussionStatus: this.props.discussion.total > 0 ? 2 : 3
      },
      () => {
        this.props.resetDiscussion();
        const backUrl = this.getBackUrl(this.props.history.location.pathname);
        this.props.history.push(backUrl);

        const statusChanged = this.props.status !== this.state.discussionStatus;

        if (
          statusChanged ||
          this.props.match.params.assignmentId ||
          markedUnread
        ) {
          this.props.onDiscussionClose();
        }
      }
    );
  };

  handleSubmit = (srId, message) => {
    return this.props.sendMessage(srId, message);
  };

  handleMarkUnread = async srId => {
    await this.props.markUnread(srId);
  };

  render() {
    return (
      <DiscussionWidget
        currentUserId={this.props.currentUserId}
        discussion={this.props.discussion}
        initials={this.props.initials}
        onDiscussionOpen={this.openDiscussion}
        onDiscussionClose={this.handleClose}
        onMessageCreate={this.handleSubmit}
        onMarkUnread={this.handleMarkUnread}
        isLoading={this.props.isLoading}
        status={this.state.discussionStatus}
        iconOnly={this.props.iconOnly}
        action={this.props.action}
        serviceRequestId={this.props.serviceRequestId}
        ticketNumber={this.props.ticketNumber}
        isLoadingMarkUnread={this.props.isLoadingMarkUnread}
        isSeen={this.props.isSeen}
      />
    );
  }
}

Discussion.propTypes = {
  t: PropTypes.func,
  initials: PropTypes.string,
  currentUserId: PropTypes.string,
  getDiscussion: PropTypes.func,
  sendMessage: PropTypes.func,
  markUnread: PropTypes.func,
  resetDiscussion: PropTypes.func,
  serviceRequestId: PropTypes.string,
  isLoading: PropTypes.bool,
  iconOnly: PropTypes.bool,
  discussion: PropTypes.object,
  hasUnread: PropTypes.bool,
  status: PropTypes.number,
  action: PropTypes.string,
  ticketNumber: PropTypes.string,
  onDiscussionClose: PropTypes.func,
  isSeen: PropTypes.bool
};

const isLoadingMessages = createLoadingSelector([
  'ServiceRequests/GetDiscussion'
]);
const isLoadingMarkUnread = createLoadingSelector([
  'ServiceRequests/MarkDiscussionUnread'
]);
const mapStateToProps = state => {
  return {
    currentUserId: state.auth.user.UserId,
    isLoading: isLoadingMessages(state),
    discussion: state.discussion,
    isLoadingMarkUnread: isLoadingMarkUnread(state)
  };
};

const mapDispatchToProps = {
  getDiscussion,
  sendMessage,
  markUnread,
  resetDiscussion,
  markAsSeen
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(Discussion))
);
